import { Component, Input } from '@angular/core';
import { RichTextEditorComponent } from '../fields/rich-text-editor/rich-text-editor.component';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UploadAttachmentsComponent } from '../fields/upload-attachments/upload-attachments.component';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';
import { CommonModule } from '@angular/common';
import { InputHelperTextComponent } from '../../input-helper-text/input-helper-text.component';
import { CaseTypeEnum } from 'app/shared/enums/case-type.enum';

@Component({
  selector: 'app-problem-details-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RichTextEditorComponent,
    UploadAttachmentsComponent,
    SelectFormFieldComponent,
    InputFormFieldComponent,
    DatepickerFormFieldComponent,
    CheckboxFormFieldComponent,
    TranslateModule,
    ConfigurationSelectFormFieldComponent,
    CommonModule,
    InputHelperTextComponent
  ],
  templateUrl: './problem-details-form.component.html',
  styleUrl: './problem-details-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ProblemDetailsFormComponent {
  @Input() attachmentsTouched!: boolean;
  @Input() extended!: boolean;
  @Input() viewMode!: boolean;
  @Input() severityItems: any = [];
  @Input() caseId!: number;
  @Input() uploadedFiles: any[] = [];
  caseType: string = CaseTypeEnum.CASE;

  form: any;
  datepickerMaxDate: Date = new Date();
  dropdownCaseType = DropdownTypeEnum.CASE_TYPE;
  dropdownClasificationType = DropdownTypeEnum.CLASSIFICATION;

  constructor(
    public mainForm: FormGroupDirective
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('caseTitle', new FormControl(null, [Validators.required]));
    this.form.addControl('caseType', new FormControl(null, [Validators.required]));
    this.form.addControl('problemDescription', new FormControl(null, [Validators.required]));
    this.form.addControl('severity', new FormControl(null, [Validators.required]));
    this.form.addControl('businessImpact', new FormControl(null, [Validators.required]));
    this.form.addControl('classification', new FormControl(null, []));
    this.form.addControl('errorCode', new FormControl(null, []));
    this.form.addControl('msDynamicsReferenceNumber', new FormControl(null, []));
    this.form.addControl('relatedCase', new FormControl(null, []));
    this.form.addControl('problemFirstOccurredDate', new FormControl(null, []));
    this.form.addControl('reoccurringProblem', new FormControl(false, []));
    this.form.addControl('troubleshootingAttached', new FormControl(false, []));
    this.form.addControl('caseAttachments', new FormControl(null, []));
    this.form.addControl('problemRecord', new FormControl({value: null, disabled: true}, []));
    this.form.addControl('problemRecordId', new FormControl({value: null, disabled: true}, []));

    if(!this.caseId) {
      this.form.get('caseType')?.setValue('Technical Product Problem');
    }
  }

  onFileUpload(attachments: any[]) {
    this.form.get('caseAttachments')?.setValue([...attachments]);
    this.form.get('caseAttachments')?.updateValueAndValidity();
    this.form.get('caseAttachments')?.markAsDirty();
  }

  goToProblemRecord() {
    const problemRecordId = this.form.get('problemRecordId')?.value;
    if(!problemRecordId) {
      return;
    }
    const url = `problem-record/${problemRecordId}`;
    window.open(url, '_blank');
  }

}
